function invalidRedirect() {
  const error = new Error('PAYMENT_REDIRECT_INVALID')
  error.code = 'PAYMENT_REDIRECT_INVALID'
  return error
}

/** Navigate the gateway's URL or serialized Shetabit RedirectionForm. */
export function redirectToPayment(value) {
  if (value == null || value === '') return false
  const form = typeof value === 'string' ? {action: value, method: 'GET'} : value
  if (!form || typeof form.action !== 'string' || !/^https?:\/\//i.test(form.action)) throw invalidRedirect()
  let url
  try { url = new URL(form.action) } catch (_) { throw invalidRedirect() }
  if (!['http:', 'https:'].includes(url.protocol)) throw invalidRedirect()
  const method = String(form.method || 'GET').toUpperCase()
  const inputs = form.inputs == null ? {} : form.inputs
  if (!['GET', 'POST'].includes(method) || !inputs || typeof inputs !== 'object') throw invalidRedirect()
  const fields = Object.entries(inputs).map(([name, value]) => {
    if (value != null && !['string', 'number', 'boolean'].includes(typeof value)) throw invalidRedirect()
    return [name, value == null ? '' : String(value)]
  })
  if (method === 'GET') {
    fields.forEach(([name, value]) => url.searchParams.append(name, value))
    window.location.assign(url.href)
    return true
  }
  const element = document.createElement('form')
  element.action = url.href
  element.method = 'POST'
  element.style.display = 'none'
  // Capture before adding inputs: a gateway field named "submit" must not shadow it.
  const submit = element.submit.bind(element)
  fields.forEach(([name, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    element.appendChild(input)
  })
  document.body.appendChild(element)
  submit()
  return true
}
